import { Alert } from "@mantine/core";
import { AlertPresets } from "../../../../mantine/mantinePresets";

function AnImportIsStoppedWarning() {
  return (
    <Alert
      className="AnImportIsStoppedWarning"
      color={AlertPresets.info.color}
      variant="light"
    >
      Der Import der farblich hinterlegten Dateien wartet auf Ihre Eingabe.
      Bitte klicken Sie dafür auf die Links in der Name-Spalte.
    </Alert>
  );
}

export { AnImportIsStoppedWarning };
